import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import dayjs from 'dayjs'

const state = {
    activeStatus: false,
    activeTransfers: false,
    isExpiringAudiences: false,
    isExpiringTransfers: false,
    ccloneList: [],
    loading: false,
    expiringAudiences: '0',
    expiringAudiencesError: false,
    expiringTransfers: '0',
    expiringTransfersError: false,
    expiringAudiencesLoading: false,
    expiringTransfersLoading: false,
    breakdown: {
        age: [],
        gender: [],
        income: [],
        education: []
    },
    breakdownLoading: false,
    selectedTimeRange: null,
    allocationData: null,
    currentAllocationTimeUnit: 'day',
    kibanaData: null,
    affinityBreakdown: [],
    percentBreakdown: [],
    collectOffline: {},
    collectOfflineLoading: false,
    collectOnline: {},
    collectOnlineLoading: false,
    taxonomiesBreakdownAffinity: [],
    taxonomiesBreakdownPurcent: [],
    taxonomiesBreakdownLoading: false,
    dateRange: [dayjs().subtract(7, 'days').toISOString(), dayjs().toISOString()],
    volumes: null,
    volumesError: false,
    loadingVolumes: false,
    loadingVolumesToken: 0,
    loadingTaxonomyBreakdownToken: 0,
}

export default {
    state,
    actions,
    namespaced: true,
    mutations,
    getters
}